import React from "react"
import PropTypes from "prop-types"
import { Descriptions, Divider } from "antd"

const DetailMember = ({ detailMember }) => {
  if (!detailMember) return null

  const formatDate = iso => {
    if (!iso || iso.startsWith("0001")) return "-"
    return new Date(iso).toLocaleDateString()
  }

  const renderItem = (label, value) =>
    value !== undefined && value !== null ? (
      <Descriptions.Item label={label}>{value || "-"}</Descriptions.Item>
    ) : null

  return (
    <div>
      {/* --- THÔNG TIN CƠ BẢN --- */}
      <Divider orientation="left">Thông tin cơ bản</Divider>
      <Descriptions column={1} bordered>
        {renderItem("Tên tổ chức", detailMember.OrganizationName)}
        {renderItem("Họ và tên", detailMember.FullName)}
        {renderItem("Đơn vị", detailMember.AccountName)}
        {renderItem("Email", detailMember.Email)}
        {renderItem("Số điện thoại", detailMember.PhoneNumber)}
        {renderItem(
          "Loại hội viên",
          detailMember.MemberType == "1" ? "Cá nhân" : "Tổ chức",
        )}
        {renderItem("Nghề nghiệp", detailMember.Occupation)}
      </Descriptions>

      {/* --- THÔNG TIN NHẬN DẠNG --- */}
      <Divider orientation="left">Thông tin nhận dạng</Divider>
      <Descriptions column={1} bordered>
        {renderItem("CMND/CCCD", detailMember.Identification)}
        {renderItem(
          "Ngày cấp",
          formatDate(detailMember.IdentificationIssueDate),
        )}
        {renderItem("Ngày sinh", formatDate(detailMember.DateOfBirth))}
        {renderItem("Mã số thuế", detailMember.TaxCode)}
        {renderItem("Ngày cấp MST", formatDate(detailMember.TaxIssuedDate))}
      </Descriptions>

      {/* --- ĐỊA CHỈ --- */}
      <Divider orientation="left">Địa chỉ</Divider>
      <Descriptions column={1} bordered>
        {renderItem("Địa chỉ cư trú", detailMember.ResidenceAddress)}
        {renderItem("Địa chỉ liên hệ", detailMember.ContactAddress)}
        {renderItem("Địa chỉ tổ chức", detailMember.Address)}
        {renderItem(
          "Địa chỉ người đại diện",
          detailMember.RepresentativeAddress,
        )}
      </Descriptions>

      {/* --- NGƯỜI ĐẠI DIỆN (NẾU CÓ) --- */}
      {(detailMember.RepresentativeName ||
        detailMember.RepresentativePhoneNumber ||
        detailMember.RepresentativePosition) && (
        <>
          <Divider orientation="left">Người đại diện</Divider>
          <Descriptions column={1} bordered>
            {renderItem(
              "Họ tên người đại diện",
              detailMember.RepresentativeName,
            )}
            {renderItem(
              "Số điện thoại người đại diện",
              detailMember.RepresentativePhoneNumber,
            )}
            {renderItem("Chức vụ", detailMember.RepresentativePosition)}
          </Descriptions>
        </>
      )}

      {/* --- GHI CHÚ --- */}
      {detailMember.Description && (
        <>
          <Divider orientation="left">Ghi chú</Divider>
          <Descriptions column={1} bordered>
            {renderItem("Ghi chú", detailMember.Description)}
          </Descriptions>
        </>
      )}
    </div>
  )
}

export default DetailMember

DetailMember.propTypes = {
  detailMember: PropTypes.object.isRequired,
}
